import React, { Suspense, memo } from 'react';
import DrilldownCard from '../DrillDownCard';

// Code-splitting: DailyCards se carga sólo al expandir
const DailyCards = React.lazy(() => import('./DailyCards'));

const DaysSkeleton = () => (
  <div className="space-y-3 py-2">
    {Array.from({ length: 7 }).map((_, i) => (
      <div key={i} className="h-20 rounded-xl bg-slate-100 dark:bg-slate-800 animate-pulse" />
    ))}
  </div>
);

const WeeklyCards = ({ weeklyMetrics, isOpen = false, onToggle }) => {
  const hasDays = Array.isArray(weeklyMetrics?.days) && weeklyMetrics.days.length > 0;

  return (
    // Wrapper de seguridad: si el card no llama onNavigate, igual toggleanos
    <div
      onClick={onToggle}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onToggle()}
    >
      <DrilldownCard
        title={weeklyMetrics.table}
        subtitle={weeklyMetrics.subtitle}
        metrics={weeklyMetrics.metrics}
        navigable
        onNavigate={onToggle} // si el card lo dispara, también funciona
        isExpanded={isOpen} // por si tu versión lo soporta
        shouldExpand={isOpen} // idem (algunas versiones usan este prop)
        aria-expanded={isOpen}
        showArrow
      >
        {/* Montamos los días sólo cuando está abierto */}
        {isOpen && (
          <div
            className="grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out"
            style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
            aria-hidden={!isOpen}
            onClick={(e) => e.stopPropagation()} // evita cerrar al clickear adentro
          >
            <Suspense fallback={<DaysSkeleton />}>
              <div
                className="min-h-0 space-y-3 py-2"
                style={{ contentVisibility: 'auto', containIntrinsicSize: '0 400px' }}
              >
                {hasDays ? (
                  weeklyMetrics.days.map((day) => <DailyCards key={day.label} dailyItems={day} />)
                ) : (
                  <div className="px-2 py-3 text-sm text-slate-500">No data for this week.</div>
                )}
              </div>
            </Suspense>
          </div>
        )}
      </DrilldownCard>
    </div>
  );
};

export default memo(WeeklyCards);
